import type { States } from '../states';

import type { AlertState } from './alert';

export const selectAlert = ({ Alert }: States): AlertState => Alert;

export const selectShowBlocked = (states: States): boolean => {
    const n = selectAlert(states);

    return n.showBlocked;
};
